import { render, staticRenderFns } from "./form-lookup.vue?vue&type=template&id=2f13a1b5&"
import script from "./form-lookup.vue?vue&type=script&lang=js&"
export * from "./form-lookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports